import { ShieldCheck } from "lucide-react";
import { InfoPage } from "../components/info/InfoPage";
import { FactorGrid, IllustratedSplit, InfoSection } from "../components/info/InfoSections";
import { StepTimeline } from "../components/info/StepTimeline";
import { CheckGrid } from "../components/info/InfoExtras";
import { DELIVERY, FACADES, MONTAGE_NAV, MONTAGE_POINTS, PLANNING_TEXT, SEAL_TEXT, STEPS } from "../data/info/montage";

const DEMONTAGE_TEXT = "Voordat het nieuwe kozijn erin gaat, moet het oude eruit. Vooral bij oude houten kozijnen in metselwerk vraagt dat zorgvuldigheid: zo blijven muur, stucwerk en vensterbank zo veel mogelijk heel en sluit het nieuwe kozijn straks strak aan.\n\nWe dekken vloer en vensterbank af, werken per kozijn en zorgen dat de woning aan het einde van de dag weer wind- en waterdicht is.";

export default function Montage() {
  return (
    <InfoPage page="montage" label="Montage & afwerking" eyebrow="Montage & afwerking" points={MONTAGE_POINTS} mediaKey="ka_montage_hero" nav={MONTAGE_NAV}
      kbCategory="montage" faqTitle="Vragen over de montage van kozijnen" endTitle="Nieuwe kozijnen, zorgvuldig geplaatst en afgewerkt?"
      badge={{ icon: ShieldCheck, title: "Binnen luchtdicht", text: "Buiten waterdicht en dampopen" }}>
      <InfoSection id="stappen" eyebrow="Stap voor stap" title="Zo verloopt de montage van nieuwe kozijnen"
        lead="Van inmeten tot oplevering: dit gebeurt er bij een kozijnvervanging, en hierop letten wij bij elke stap.">
        <StepTimeline steps={STEPS} />
        <div className="mt-14"><IllustratedSplit mediaKey="ka_montage_demontage" title="Zorgvuldig demonteren" text={DEMONTAGE_TEXT} testid="montage-demontage-split" /></div>
      </InfoSection>
      <InfoSection id="gevel" tone="slate" eyebrow="Uw gevel" title="Elke gevel vraagt een eigen aanpak"
        lead="De muuropbouw en de bereikbaarheid bepalen hoe we een kozijn plaatsen, bevestigen en afdichten.">
        <FactorGrid items={FACADES} testid="montage-facades" />
      </InfoSection>
      <InfoSection id="afdichting" eyebrow="Afdichting" title="Luchtdicht, geïsoleerd en waterdicht">
        <IllustratedSplit mediaKey="ka_montage_plaatsen" text={SEAL_TEXT} testid="montage-seal-split" />
      </InfoSection>
      <InfoSection id="planning" tone="slate" eyebrow="Planning" title="Hoe lang duurt de montage en wat kunt u voorbereiden?">
        <IllustratedSplit mediaKey="ka_montage_profiel" text={PLANNING_TEXT} reverse testid="montage-planning-split" />
      </InfoSection>
      <InfoSection id="oplevering" eyebrow="Oplevering" title="Dit controleren we samen bij de oplevering"
        lead="Pas als alles werkt en netjes is afgewerkt, is de montage klaar.">
        <CheckGrid items={DELIVERY} testid="montage-delivery" />
      </InfoSection>
    </InfoPage>
  );
}
